import { useSlideToggle } from '@/hooks/useSlideToggle';
import type { UseSlideToggleConfig } from '@/hooks/useSlideToggle/types';
import { animated } from '@react-spring/web';
import CourseDetailCardButton from '@uikit/components/CourseDetailCard/CourseDetailCardButton/CourseDetailCardButton';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import RichText from '../../RichText/RichText';
import styles from './CourseDetailCardContent.module.scss';

const toggleHookConfig: UseSlideToggleConfig = {
  name: 'courseDetailCardContent',
  minHeight: 130,
};

const CourseDetailCardContent = ({ children }: PropsWithChildren) => {
  const { animationProps, animatedElementRef, elementID, isOpen, toggle } =
    useSlideToggle(toggleHookConfig);

  const buttonLabel = `${isOpen ? 'Weniger' : 'Alle'} anzeigen`;

  return (
    <div className={styles.base}>
      <animated.div
        style={animationProps}
        className={clsx(styles.wrapper, { [styles.isOpen]: isOpen })}
      >
        <div
          ref={animatedElementRef}
          id={elementID}
          role="region"
          aria-labelledby={elementID}
        >
          <RichText className={styles.content}>{children}</RichText>
        </div>
      </animated.div>

      <CourseDetailCardButton
        onClick={toggle}
        aria-expanded={isOpen}
        aria-controls={elementID}
      >
        {buttonLabel}
      </CourseDetailCardButton>
    </div>
  );
};

export default CourseDetailCardContent;
